module.exports = __webpack_public_path__ + "static/src/content/images/processed/200/queen.4f0eddc.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/images/processed/200/queen.jpg
// module id = BN/h
// module chunks = 0